<template>
  <v-container>
    <v-row>
      <v-col class="col-12 pa-0 d-flex justify-center"
        ><v-img
          v-if="producer.producer == 'SALAMANDER'"
          class="ma-2"
          contain
          max-width="150"
          lazy-src="@/assets/ProducersLogo/lazyTPlogo.jpg"
          src="@/assets/ProducersLogo/salamander-logo.png"
        ></v-img>
        <v-img
          v-else-if="producer.producer == 'Gealan'"
          class="my-2"
          contain
          max-width="140"
          lazy-src="@/assets/ProducersLogo/lazyTPlogo.jpg"
          src="@/assets/ProducersLogo/gealan-logo.png"
        ></v-img>
        <v-img
          v-else-if="producer.producer == 'DECEUNINCK'"
          class="my-2"
          contain
          max-width="140"
          lazy-src="@/assets/ProducersLogo/lazyTPlogo.jpg"
          src="@/assets/ProducersLogo/deceuninck_logo.png"
        ></v-img>
        <v-img
          v-else-if="producer.producer == 'ALUPLAST SP. Z O.O.'"
          class="my-2"
          contain
          max-width="150"
          lazy-src="@/assets/ProducersLogo/lazyTPlogo.jpg"
          src="@/assets/ProducersLogo/aluplast-logo.png"
         
        ></v-img>
        <v-img
          v-else-if="producer.producer == 'TERMO PROFIL'"
          class="my-2"
          contain
          max-width="150"
          lazy-src="@/assets/ProducersLogo/lazyTPlogo.jpg"
          src="@/assets/ProducersLogo/tp-logo.png"
         
        ></v-img>

        <v-img
          v-else-if="producer.producer == 'KN'"
          class="my-2"
          contain
          max-width="150"
          lazy-src="@/assets/ProducersLogo/lazyTPlogo.jpg"
          src="@/assets/ProducersLogo/kn-logo.png"
      ></v-img>
    </v-col>
      <v-col class="col-12 pa-0"
        ><v-card-subtitle class="pa-0 title">
          {{ producer.profil }}
        </v-card-subtitle></v-col
      >
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    producer: {},
  },
  data() {
    return {
      clickCounter: 0,
    };
  },
  methods: {
    addClick() {
      this.clickCounter += this.clickCounter;
    },
  },
};
</script>
